import React from 'react'

const VehicleIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">
            <path
                fill="#4A5B6D"
                fillRule="evenodd"
                d="M15.92 2.01C15.72 1.42 15.16 1 14.5 1h-11c-.66 0-1.21.42-1.42 1.01L.11 7.68c-.07.21-.11.43-.11.66v7.16c0 .83.67 1.5 1.5 1.5S3 16.33 3 15.5V15h12v.5c0 .82.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5V8.34c0-.22-.04-.45-.11-.66l-1.97-5.67zM3.5 12c-.83 0-1.5-.67-1.5-1.5S2.67 9 3.5 9 5 9.67 5 10.5 4.33 12 3.5 12zm11 0c-.83 0-1.5-.67-1.5-1.5S13.67 9 14.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM2 7l1.27-3.82c.14-.4.52-.68.95-.68h9.56c.43 0 .81.28.95.68L16 7H2z"
            />
        </svg>
    )
}

export default VehicleIcon
